<!--<p-toast [style]="{marginTop: '80px'}"></p-toast>-->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}


<div>
  <div class="p-4">
    <form [formGroup]="form1">

      <div class="p-fluid p-formgrid d-flex flex-wrap gap-3 align-items-center">
        <div class="p-field">
          <p-rating formControlName="rating" cancel=false stars=5></p-rating>
          @for (validation of validationMessages.rating; track validation) {
            <span>
              @if (form1.get('rating').hasError(validation.type) && (form1.get('rating').dirty || form1.get('rating').touched)) {
                <small id="rating2-help" class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div class="p-field">
          <a (click)="openGuestExitSurveyDialog()" class="p-button p-button-outlined p-button-info">Guest Exit Survey</a>
        </div>
        <div class="p-field">
          <button class="mr-3 p-button-outlined p-button-info" pButton
          type="button" label="Create From Reservation" (click)="onFindReservationClick()"></button>
        </div>


        <div class="p-field col-12">
          <span class="p-float-label">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small id="title2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="p-field col-12">
          <span class="p-float-label">
            <textarea formControlName="reviewDesc" id="reviewDesc" [rows]="5" pInputTextarea
            onkeyup="document.getElementById('reviewDescLength').value = this.value.length"></textarea>
            <input style="border:0px; width:30px" disabled="disabled" id="reviewDescLength" type="text" />
            <label for="reviewDesc">Guest Review</label>
            @for (validation of validationMessages.reviewDesc; track validation) {
              <span>
                @if (form1.get('reviewDesc').hasError(validation.type) && (form1.get('reviewDesc').dirty || form1.get('reviewDesc').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="p-field col-12">
          <span class="p-float-label">
            <textarea formControlName="responseDesc" id="responseDesc" [rows]="5" pInputTextarea
            onkeyup="document.getElementById('reviewResponseLength').value = this.value.length"></textarea>
            <input style="border:0px; width:30px" disabled="disabled" id="reviewResponseLength"
              type="text" />
              <label for="responseDesc">KBM Response</label>
              @for (validation of validationMessages.responseDesc; track validation) {
                <span>
                  @if (form1.get('responseDesc').hasError(validation.type) && (form1.get('responseDesc').dirty || form1.get('responseDesc').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="col-lg-12">
            <h6 for="guestFollowupRequest">Google Review Submitted?</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['guestFollowupRequest']" inputId="guestFollowupRequest" [binary]="true"></p-checkbox>
              <span class="guestExitSurvey-nm"> Google Review Submitted</span>
            </div>
            @for (validation of validationMessages.guestFollowupRequest; track validation) {
              <span>
                @if (form1.get('guestFollowupRequest').hasError(validation.type) && (form1.get('guestFollowupRequest').dirty || form1.get('guestFollowupRequest').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>

          <div class="col-lg-12">
            <h6 for="yelpReviewRequest">Yelp Review Submitted?</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['yelpReviewRequest']" inputId="yelpReviewRequest" [binary]="true"></p-checkbox>
              <span class="guestExitSurvey-nm"> Yelp Review Submitted</span>
            </div>
            @for (validation of validationMessages.yelpReviewRequest; track validation) {
              <span>
                @if (form1.get('yelpReviewRequest').hasError(validation.type) && (form1.get('yelpReviewRequest').dirty || form1.get('yelpReviewRequest').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>

          <div class="p-field">
            <span class="p-float-label">
              <input formControlName="helpfulCount" id="helpfulCount" type="text" pInputText>
              <label for="helpfulCount">Helpful #</label>
              @for (validation of validationMessages.helpfulCount; track validation) {
                <span>
                  @if (form1.get('helpfulCount').hasError(validation.type) && (form1.get('helpfulCount').dirty || form1.get('helpfulCount').touched)) {
                    <small id="helpfulCount2-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>

            <span class="p-float-label">
              <input formControlName="notHelpfulCount" id="notHelpfulCount" type="text" pInputText>
              <label for="notHelpfulCount">Not Helpful #</label>
              @for (validation of validationMessages.notHelpfulCount; track validation) {
                <span>
                  @if (form1.get('notHelpfulCount').hasError(validation.type) && (form1.get('notHelpfulCount').dirty || form1.get('notHelpfulCount').touched)) {
                    <small id="notHelpfulCount2-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="mt-2 col-12">
            <h4>Property</h4>
          </div>



          <div class="p-field col-6">
            <span class="p-float-label">
              <p-dropdown [options]="statuses" formControlName="status" optionLabel="name" optionValue="value"
              placeholder="Status"></p-dropdown>
              <label for="Status">Status</label>
              @for (validation of validationMessages.status; track validation) {
                <span>
                  @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>


          <div class="p-field col-6">
            <span class="p-float-label">
              <p-dropdown [options]="properties" formControlName="shortTermRentalId"
                optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true"
                filterBy="propertyCode" [showClear]="false" placeholder="Select Property">
              </p-dropdown>
              <label for="Select Property">Select Property</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="p-field col-12 md:col-6">
            <span class="p-float-label">
              <p-calendar formControlName="checkInDate" inputId="checkInDate">
              </p-calendar>
              <label for="checkInDate">Check-In Date</label>
              @for (validation of validationMessages.checkInDate; track validation) {
                <span>
                  @if (form1.get('checkInDate').hasError(validation.type) && (form1.get('checkInDate').dirty || form1.get('checkInDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>


          <div class="p-field col-12 md:col-6">
            <span class="p-float-label">
              <p-calendar formControlName="reviewDate" inputId="reviewDate">
              </p-calendar>
              <label for="reviewDate">Review Date</label>
              @for (validation of validationMessages.reviewDate; track validation) {
                <span>
                  @if (form1.get('reviewDate').hasError(validation.type) && (form1.get('reviewDate').dirty || form1.get('reviewDate').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="p-field col-6">
            <span class="p-float-label">
              <p-dropdown [options]="activities" formControlName="activityId"
                optionLabel="name" optionValue="activityId" [filter]="true"
                filterBy="name" [showClear]="false" placeholder="Select Activity">
              </p-dropdown>
              <label for="Select Activity">Select Activity</label>
              @for (validation of validationMessages.activityId; track validation) {
                <span>
                  @if (form1.get('activityId').hasError(validation.type) && (form1.get('activityId').dirty || form1.get('activityId').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="mt-2 col-6">

            <div>
              <!-- <a routerLink="/reservations/{{review?.reservationId}}" routerLinkActive="active"
              target="_blank" rel="bookmark">View Reservation ID: <b>{{review?.reservationId}}</b></a> -->
              <a (click)="findReservationById(review?.reservationId)" style="color: #2196F3;" rel="bookmark">View Reservation ID: <b>{{review?.reservationId}}</b></a>
            </div>
            <div>
              <app-reservation-search [showDialog]="showReservationSearch"
              (reservation)="setReservation($event)"></app-reservation-search>
            </div>
          </div>


          <div class="mt-4 col-12">
            <h4>Guest</h4>
          </div>


          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input formControlName="firstName" id="firstName" type="text" pInputText>
              <label for="firstName">First Name</label>
              @for (validation of validationMessages.firstName; track validation) {
                <span>
                  @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                    <small id="firstName2-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input formControlName="lastName" id="lastName" type="text" pInputText>
              <label for="lastName">Last Name</label>
              @for (validation of validationMessages.lastName; track validation) {
                <span>
                  @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                    <small id="lastName2-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input formControlName="emailAddress" id="emailAddress" type="text" pInputText>
              <label for="emailAddress">Email</label>
              @for (validation of validationMessages.emailAddress; track validation) {
                <span>
                  @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                    <small id="emailAddress2-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>


          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input formControlName="city" id="city" type="text" pInputText>
              <label for="city">City</label>
              @for (validation of validationMessages.city; track validation) {
                <span>
                  @if (form1.get('city').hasError(validation.type) && (form1.get('city').dirty || form1.get('city').touched)) {
                    <small id="city2-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <!--<div class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <input formControlName="state" id="state" type="text" pInputText>
            <label for="state">State / Province</label>
            <span *ngFor="let validation of validationMessages.state">
              <small id="state2-help" class="p-invalid"
                *ngIf="form1.get('state').hasError(validation.type) && (form1.get('state').dirty || form1.get('state').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div>-->

        <div class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <p-dropdown [options]="states" formControlName="state" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select State / Province">
            </p-dropdown>
            <label for="Select State / Province">Select State / Province</label>
            @for (validation of validationMessages.state; track validation) {
              <span>
                @if (form1.get('state').hasError(validation.type) && (form1.get('state').dirty || form1.get('state').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <p-dropdown [options]="countries" formControlName="country" optionLabel="name" appendTo="body"
              optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select Country">
            </p-dropdown>
            <label for="Select Country">Select Country</label>
            @for (validation of validationMessages.country; track validation) {
              <span>
                @if (form1.get('country').hasError(validation.type) && (form1.get('country').dirty || form1.get('country').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <input formControlName="screenName" id="screenName" type="text" pInputText>
            <label for="screenName">Screen Name</label>
            @for (validation of validationMessages.screenName; track validation) {
              <span>
                @if (form1.get('screenName').hasError(validation.type) && (form1.get('screenName').dirty || form1.get('screenName').touched)) {
                  <small id="screenName2-help" class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="p-field col-12">
          <span class="p-float-label">
            <textarea formControlName="notes" id="notes" [rows]="2" pInputTextarea
            ></textarea>

            <label for="notes">Internal Notes</label>
            @for (validation of validationMessages.notes; track validation) {
              <span>
                @if (form1.get('notes').hasError(validation.type) && (form1.get('notes').dirty || form1.get('notes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>


      <div class="mt-4 grid">
        <div class="col-4">
          <div class="flex justify-content-start">
            @if (review) {
              <button pButton type="button" class="p-button-outlined p-button-danger"
              label="Delete" (click)="onDeleteClick()"></button>
            }
          </div>
        </div>
        <div class="col-8">
          <div class="flex justify-content-end">
            <button class="mr-5 p-button-outlined p-button-info" pButton type="button" label="Close"
            (click)="onCloseClick()"></button>
            @if (review) {
              <button pButton type="button" label="Update" (click)="onUpdateClick()"></button>
            }
            @if (!review) {
              <button pButton type="button" label="Submit" (click)="onAddClick()"></button>
            }
          </div>
        </div>
        <div class="flex justify-content-end">
          @if (formErrorMessage) {
            <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
          }
        </div>
      </div>
    </form>
  </div>

</div>
